import {Type} from "class-transformer";

import {serializeType} from "../classes/common";
import {AnswerType} from "../enums/answer-type.enum";
import {QuestionType} from "../enums/question-type.enum";

export class ScreeningQuestionChoice {
  id?: number;
  version?: number;
  type: AnswerType;
  text: string;
  questionId: number;

  constructor(question?: ScreeningQuestion) {
    if (question) {
      this.questionId = question.id;
    }
  }
}

export class ScreeningQuestionAnswer {
  id?: number;
  version?: number;
  type?: AnswerType;
  text?: string;
  grade: number;
}

export class ScreeningQuestion {
  id?: number;
  version?: number;
  type: QuestionType;
  active: boolean;
  orgId: number;
  categoryId: number;
  categoryName: string;

  text: string;
  evalWeight: number;
  @Type(serializeType(ScreeningQuestionChoice)) choices?: Array<ScreeningQuestionChoice>;
  @Type(serializeType(ScreeningQuestionAnswer)) answer?: ScreeningQuestionAnswer;

  constructor() {
      this.choices = [];
  }
}
